import React, { useEffect } from "react";
import { styled } from "styled-components";
import { Text } from "../../TextConstants";

const TotalAmountCard = ({ amount }) => {
  return (
    <TotalContainer>
      <TotalLabel>{Text.total}</TotalLabel>
      <TotalAmount>{amount} {Text.qar}</TotalAmount>
    </TotalContainer>
  );
};

const TotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const TotalLabel = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
`;
const TotalAmount = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
`;

export default TotalAmountCard;
